<template>
	<div class="">
        <template v-if="create_payroll_batch === true">
            <div class="page-top mb-1 mb-3 align-center clearfix">
                <h1 class="float-left"> Generate Payroll </h1>
                <button class="btn btn-primary float-right" @click="proceesToAutoGenerateProcess">Next</button>
                <router-link class="btn btn-primary float-right mr-1" to="employeePayments">Cancel</router-link>
            </div>
            <div class="auto-generate-main">
                <div class="auto-generate-inner">
                    <div class="alert alert-warning pr-3 pl-3 mb-4" role="alert" v-if="userNullSalaries > 0">
                    Salary details for the following users do not seem right! <router-link to="employees">Click here</router-link>
                    </div>
                    <div class="form-group">
                        <input type="text" class="form-control" name="title" v-model="form.title" placeholder="What would you like to call this batch." :class="{ 'is-invalid': form.errors.has('title') }" autocomplete="off"/>
                        <has-error :form="form" field="title"></has-error>
                    </div>
                    <label for="" class="label block-label"> Payroll Month </label>
                    <div class="form-group">
                        <datepicker :minimumView="'month'" :maximumView="'month'" input-class="datepicker" :bootstrap-styling="true" :clear-button="true" placeholder="Select Month" name="time_period" v-model="form.time_period" :class="{ 'is-invalid': form.errors.has('time_period') }" ></datepicker>
                        <!-- <input type="month" class="form-control" name="time_period" v-model="form.time_period" :class="{ 'is-invalid': form.errors.has('time_period') }" /> -->
                        <has-error :form="form" field="time_period"></has-error>
                    </div>
                </div>
            </div>
        </template>
        <template v-else-if="create_payroll_batch === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="create_payroll_batch === false">
            <notAllowed></notAllowed>
        </template>
	</div>
</template>

<script>

    export default {
        data() {
            return {
                form: new Form({
                    title : '',
                    time_period : '',
                }),
                userNullSalaries: 0,
                create_payroll_batch:  null
            }
        },
        methods: {
            getAutoGenerateData(){
                // $('.datepicker').datepicker({
                //     format: "mm-yyyy",
                //     viewMode: "months",
                //     minViewMode: "months",
                //     autoclose: false,
                //     todayBtn: "linked"
                // });
                axios.get('/api/getAutoGenerateData')
                .then(res => {
                    this.userNullSalaries = res.data.userNullSalaries;
                })
                .catch(err => {
                    this.showAlertBox('error','Error to load data');
                });
            },
            proceesToAutoGenerateProcess(){
                this.$Progress.start();
                this.form.post('/api/processAutoPayroll')
                .then(res => {
                    if(res.status == '200'){
                        this.$Progress.finish();
                        this.$router.push('autoPaymentUsers/'+res.data.id);
                    }
                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','Some error in your form data');
              });
            }
        },
        created() {

        },
        mounted() {
            this.$Progress.start();
			this.can('create_payroll_batch').then(result => {
                this.create_payroll_batch = result.create_payroll_batch;
            }).then(result => {
                if(this.create_payroll_batch == true){
					this.getAutoGenerateData();
                    this.$Progress.finish();
                }else{
                    this.$Progress.finish();
                }
            });

        },
    }
</script>
